import { FC } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { PositionProps } from "../../../styled";
import { StyledWrap } from "./style";

const ScrollBar: FC<PositionProps> = ({ children, ...rest }) => {
  return (
    <StyledWrap {...rest}>
      <PerfectScrollbar>{children}</PerfectScrollbar>
    </StyledWrap>
  );
};

export default ScrollBar;
